import { useDeviceType, type IAccordionItemClickEvent } from '@cian/ui-kit';

import { Faq } from 'shared/components/Faq';
import { useGuideAnalytics } from 'shared/hooks';
import type { TFaqItem } from 'shared/types/faq';

interface IFaqContainerProps {
  items: TFaqItem[];
  compactTop?: boolean;
}

export const FaqContainer: React.FC<IFaqContainerProps> = ({ items, compactTop }) => {
  const device = useDeviceType();
  const isPhone = device === 'phone';
  const accordionSize = isPhone ? 'S' : 'M';
  const { trackFaqLinkClick, trackFaqQuestionOpen } = useGuideAnalytics();

  const handleItemClick = ({ open, index, target }: IAccordionItemClickEvent): void => {
    if (!open) {
      return;
    }

    trackFaqQuestionOpen(index + 1, target.title);
  };

  const getLinkClickHandler = (questionId: number, question: string) => {
    return (link: string): void => {
      trackFaqLinkClick(questionId, question, link);
    };
  };

  return (
    <Faq
      device={device}
      title={isPhone ? 'Вопросы' : 'Ответы на вопросы'}
      accordionSize={accordionSize}
      items={items}
      compactTop={compactTop}
      onItemClick={handleItemClick}
      getLinkClickHandler={getLinkClickHandler}
    />
  );
};
